import { LegalPage, LEGAL } from "@/components/LegalPage";

const sections = [
  { h: "Attorney advertising", p: [
    `The "Find a Lawyer" directory is a paid advertising service. Attorneys pay ${LEGAL.company} a membership fee to be listed. Listings are attorney advertising and are written by the attorneys themselves.`,
  ]},
  { h: "How listings are ordered", p: [
    "Placement depends on membership tier: Elite listings appear first, then Pro, then Basic. Pro and Elite listings are highlighted. Placement reflects what an attorney pays, not a ranking of skill, experience or results.",
  ]},
  { h: "What the \"Verified\" badge means", p: [
    `The Verified badge shows an attorney holds an Elite membership. ${LEGAL.company} does not independently confirm bar admission, disciplinary history or credentials. Always check an attorney's license with your state bar before hiring them.`,
  ]},
  { h: "No endorsement or referral", p: [
    `${LEGAL.company} does not recommend, endorse or vouch for any attorney, and is not a lawyer referral service. We do not take part of any legal fee, and we never charge you for sending a consult request.`,
  ]},
  { h: "Consult requests", p: [
    "When you send a consult request, your name, contact details and message go only to the attorney you choose. Sending a request does not create an attorney-client relationship, and the attorney isn't obligated to take your case. Don't include confidential details until you've spoken with the attorney.",
  ]},
  { h: "Results", p: [
    "Past results described by any attorney don't guarantee a similar outcome. Every case depends on its own facts and law.",
  ]},
];

export default function Disclosures() {
  return <LegalPage id="disclosures" title="Attorney Directory Disclosures" sections={sections}
    intro="Please read these disclosures before choosing a lawyer from our directory." />;
}
